function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "Path_1313",
  x: 87.006,
  y: 49.922,
  width: 113.044,
  height: 110.662,
  filterUnits: "userSpaceOnUse"
}, React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), React.createElement("feFlood", {
  floodOpacity: 0.161
}), React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1614",
  "data-name": "Group 1614",
  transform: "translate(-788.201 -345.987)"
}, React.createElement("path", {
  id: "Path_1312",
  "data-name": "Path 1312",
  d: "M119.273-4.156c87.368,0,206.508,112.874,206.508,201.811S257.919,285.5,170.551,285.5s-193.5-33.939-193.5-122.876S31.9-4.156,119.273-4.156Z",
  transform: "translate(811.151 350.143)",
  fill: "#f2f2f2"
}), React.createElement("g", {
  id: "humaaan-5",
  transform: "translate(968.013 475.811)"
}, React.createElement("g", {
  id: "Head_Front_Long",
  "data-name": "Head/Front/Long",
  transform: "matrix(-0.966, -0.259, 0.259, -0.966, 71.16, 36.094)"
}, React.createElement("path", {
  id: "Hair-Back",
  d: "M17.868,18.207C19.249,13.22,21.076,1.785,19.233,0H7.642l0,.061A8.6,8.6,0,0,0,0,8.6v8.168a8.594,8.594,0,0,0,8.594,8.594h.8A8.6,8.6,0,0,0,17.868,18.207Z",
  transform: "translate(5.596 5.141)",
  fill: "#535962",
  fillRule: "evenodd"
}), React.createElement("g", {
  id: "Head",
  transform: "translate(6.795 0)"
}, React.createElement("path", {
  id: "Path_1262",
  "data-name": "Path 1262",
  d: "M3.3,15.257a10.678,10.678,0,0,0-2.88,7.712c.6,8.478,12.508,6.613,14.824,2.334s2.041-15.134-.953-15.9c-1.194-.305-3.737.442-6.326,1.988L9.593,0H0Z",
  transform: "translate(0 0)",
  fill: "#fff",
  fillRule: "evenodd"
})), React.createElement("path", {
  id: "Hair-Front",
  d: "M12.691,11.355C13.133,6.65,12.956,1.276,11.639,0H.047c-.646,11.122,5.6,6.815,5.6,17.287.389.377.757.75,1.121,1.072l-.013.308q3.011,6.109,7.64,6.109c4.629,0,6.09-2.135,7.334-3.947-.93-3.164-4.54-3.633-7.748-5.6a2.187,2.187,0,1,1-1.385-3.871Z",
  transform: "translate(0 5.334)",
  fill: "#535962",
  fillRule: "evenodd"
})), React.createElement("g", {
  id: "Bottom_Standing_Skirt",
  "data-name": "Bottom/Standing/Skirt",
  transform: "translate(6.927 64.68)"
}, React.createElement("path", {
  id: "Skirt-Shadow",
  d: "M149.72,95.107q-14.383,4.008-24.819,4.008a33.476,33.476,0,0,1-19.386-6.172Q119.59,88.83,128.7,88.83T149.72,95.107Z",
  transform: "translate(-81.931 -54.124)",
  fill: "#535962",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Leg",
  d: "M148.976,46.915a2.248,2.248,0,0,0,.232-.452C150.49,43.086,171.02,6.66,173.066,0H149.952c-1.555,5.063-8.554,36.839-9.539,43.179-3.108,10-9.507,42.387-10.324,44.631-.859,2.36,3.976,4.819,5.264,1.917a246.264,246.264,0,0,0,9.11-25.193C146.5,57.221,148.163,50.642,148.976,46.915Z",
  transform: "translate(-114.307 1.926)",
  fill: "#fff",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Leg-2",
  "data-name": "Leg",
  d: "M24.976,51.362C34.362,53.725,68.694,58,71.05,58.667c2.424.689,4.549-4.287,1.553-5.365a248.582,248.582,0,0,0-25.865-7.3c-6.405-1.3-12.25-2.362-16.174-2.984C30.9,32.042,32.417,5.691,31.42,0H10.969C11.924,5.458,20,45.279,21.5,49.266,21.975,50.689,23.4,51.317,24.976,51.362Z",
  transform: "translate(28.603 1.926)",
  fill: "#fff",
  fillRule: "evenodd"
}), React.createElement("g", {
  id: "Accessories_Shoe_Flat-Sneaker",
  "data-name": "Accessories/Shoe/Flat-Sneaker",
  transform: "translate(106.882 54.221) rotate(100)"
}, React.createElement("path", {
  id: "shoe",
  d: "M.671,5.835A8.583,8.583,0,0,1,0,3.156,20.057,20.057,0,0,1,.36,0H22.905q.879,2.905-1.015,3.137t-3.146.418L8.266,8.227a.4.4,0,0,1-.528-.2l0-.01L7.06,6.38a7.189,7.189,0,0,0-2.849-.818,6.451,6.451,0,0,0-2.459.719h0a.8.8,0,0,1-1.06-.394Q.681,5.862.671,5.835Z",
  transform: "translate(0 0)",
  fill: "#535962",
  fillRule: "evenodd"
})), React.createElement("g", {
  id: "Accessories_Shoe_Flat-Sneaker-2",
  "data-name": "Accessories/Shoe/Flat-Sneaker",
  transform: "translate(0 88.89)"
}, React.createElement("path", {
  id: "shoe-2",
  "data-name": "shoe",
  d: "M23.6,23.367a8.583,8.583,0,0,1,.671,2.68,20.057,20.057,0,0,1-.36,3.156H1.362Q.483,26.3,2.376,26.065t3.146-.418L16,20.976a.4.4,0,0,1,.528.2l0,.01.674,1.634a7.189,7.189,0,0,0,2.849.818,6.451,6.451,0,0,0,2.459-.719h0a.8.8,0,0,1,1.06.394Q23.586,23.34,23.6,23.367Z",
  transform: "translate(-1.083 -20.941)",
  fill: "#535962",
  fillRule: "evenodd"
})), React.createElement("path", {
  id: "Skirt",
  d: "M130.978-3.294c-9.012-2.569-9.937-2.569-17.979,0-2.8,12.717-9.6,17.764-10.792,37.261,13.59,6.727,30.378-4.8,44.369,1.762C150.573,26.554,137.374,4.456,130.978-3.294Z",
  transform: "translate(-78.624 5.22)",
  fill: "#636871",
  fillRule: "evenodd"
})), React.createElement("g", {
  id: "Body_Pointing-Forward",
  "data-name": "Body/Pointing-Forward",
  transform: "translate(70.557 85.928) rotate(-170)"
}, React.createElement("g", {
  id: "Group_1606",
  "data-name": "Group 1606"
}, React.createElement("path", {
  id: "Skin",
  d: "M0,12.465l13.874,7.561a34.256,34.256,0,0,0,6.82,6.352c.684.284,1.881.456.762-1.52s-2.207-4.105-1.637-4.714,1.992.242,2.672-.77q.68-1.012-7.286-3.2L5.123,6.993Zm21.729-6.38,6.094,3.331q1.283,4.857,3.067,4.887c.914.423-.677-3.668,1.054-3.313s5.959,3.483,6.687,2.848c1.078-.94.117-3.825-1.015-5.26-2.116-2.683-3.868-3.6-8.2-4.8A23.847,23.847,0,0,1,22.076,0Z",
  transform: "translate(32.543 28.158)",
  fill: "#fff",
  fillRule: "evenodd"
})), React.createElement("path", {
  id: "Union_4",
  "data-name": "Union 4",
  d: "M15.019,57.608c-1.217,0-9.482-15.768-9.49-26.012C5.522,22.242-3.225,16.3,1.3,1.681c2.638.516,7.18-.115,12.06-.745C21.84-.161,31.347-1.257,33.676,3.67a25.081,25.081,0,0,1,2.083,12.252c7.356.16,16.285,2.574,26.7,7.988q.341,3.962-4.178,13.263-18.216-6.45-25.954-4.529-.125.422-.252.845c5.154.821,10.618,4.222,14.678,8.233L44.04,47.747a34.316,34.316,0,0,0-14.716-5.228A75.477,75.477,0,0,0,26.11,57.608Z",
  transform: "translate(0 0)",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_1605",
  "data-name": "Group 1605",
  transform: "translate(876 419.066) rotate(-11)"
}, React.createElement("g", {
  id: "confirmed-mail--color",
  transform: "translate(0 0)"
}, React.createElement("g", {
  id: "_1",
  "data-name": 1,
  transform: "translate(0 0)"
}, React.createElement("g", {
  id: "mail--color_copy",
  "data-name": "mail--color copy"
}, React.createElement("path", {
  id: "Path_1245",
  "data-name": "Path 1245",
  d: "M49.711,0,0,22.958,49.711,65.286,99.4,22.958Z",
  transform: "translate(0 19.946)",
  fill: "#388c8c"
}), React.createElement("g", {
  transform: "matrix(0.98, 0.19, -0.19, 0.98, -72.24, -88.49)",
  filter: "url(#Path_1313)"
}, React.createElement("path", {
  id: "Path_1313-2",
  "data-name": "Path 1313",
  d: "M0,0H81.555V78.543H0Z",
  transform: "translate(96.01 71.48) rotate(-11)",
  fill: "#fff"
})), React.createElement("path", {
  id: "Path_1246",
  "data-name": "Path 1246",
  d: "M49.711,40.983,0,12.22V75.552H99.4V12.22Z",
  transform: "translate(0 30.684)",
  fill: "currentColor"
})))), React.createElement("text", {
  id: "Thank_you_",
  "data-name": "Thank you!",
  transform: "translate(49.64 31.777)",
  fill: "#535962",
  fontSize: 12,
  fontFamily: "SourceSansPro-Bold, Source Sans Pro",
  fontWeight: 700
}, React.createElement("tspan", {
  x: -29.784,
  y: 0
}, "Thank you!"))));

var SvgIconThankYou = function SvgIconThankYou(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 320,
    viewBox: "0 0 348.731 291.655",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconThankYou, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-thank-you.ad4147c2.svg";
export { ForwardRef as ReactComponent };